import React, { createRef } from "react";
import BaseManageShareTaskComplete from "../baseManageShareTaskComplete";
import ReviseShareTaskReadOnly from "../../../sections/sharedTaskSections/reviseShareTaskReadOnly";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";

const procedureFileRef = createRef();

export default class ReviseShareTaskComplete extends BaseManageShareTaskComplete {
  constructor(props: any) {
    super(props);
    const { rejectReason, rejectStatus } = this.props.pageProps;
    this.state = {
      pageState: {
        rejectReason,
        rejectStatus,
        isCancelDisabled: false,
        isSubmitDisabled: false,
        isRejectDisabled: false,
        isTableBorderError: false,
        isChange: false,
      },
    };
  }
  /* function about control save button disable when procedure file table change */
  cancelIsTableChange = () => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        isChange: false,
      },
    });
  };

  /* function about control save button disable when procedure file table change */
  setIsTableChange = () => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        isChange: true,
      },
    });
  };

  handleReturnPageName = () => {
    return "Revise Shared Tasks";
  };

  handleReturnShareTaskSection = () => {
    const { shareTaskData } = this.props;

    return <ReviseShareTaskReadOnly shareTaskData={shareTaskData} />;
  };

  handleReturnProcedureFileSection = () => {
    const { serverPathValue, savedInRadioValue, fileTableData, jbProcedureSavedIn } = this.props;

    return (
      <ReadOnlyProcedureFileSection
        procedureFileRef={procedureFileRef}
        clientServerPath={serverPathValue}
        savedInRadioValue={savedInRadioValue}
        procedureFileData={fileTableData !== undefined ? fileTableData : []}
        jbProcedureSavedIn={jbProcedureSavedIn}
      />
    );
  };
}
